import { getMediaLightboxCurrentItem } from '@ms/yammer-data/dist/domains/mediaLightbox/selectors';
import type { YammerState } from '@ms/yammer-data/dist/state/types';
import type { FC } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';

import MediaLightbox from './LoadableMediaLightbox';

const LazyMediaLightbox: FC = () => {
  const isShowing = useSelector((state: YammerState) => !!getMediaLightboxCurrentItem(state));

  return isShowing ? <MediaLightbox /> : null;
};

export default LazyMediaLightbox;
